import * as PaginationConstants from "@/constants/pagination";

export function setPagination(pagination, requestType) {
  return {
    type: PaginationConstants.SET_PAGINATION,
    requestType,
    pagination
  };
}